import { locales } from 'types/language';

const LOCALE_STORAGE_KEY = 'locale';
const SUPPORTED_LOCALES = Object.values(locales);

export const getStoredLocale = () => {
  const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY);
  return SUPPORTED_LOCALES.includes(stored) ? stored : null;
};

export const storeLocale = (locale) => {
  window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
};
